var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductWaterUsageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29241 9.67607C0.0819654 16.5228 -0.778368 25.8584 3.23626 33.4681C13.3193 52.5793 46.4692 49.2642 44.7768 23.4976C46.6685 -1.06019 17.5486 -6.42955 5.29241 9.67607ZM28.9736 27.5506C28.1949 30.9203 24.8322 33.0795 21.4067 32.2542C17.9857 31.4801 15.8732 28.0618 16.6474 24.6409C16.7175 24.2737 17.2109 23.4558 18.0951 21.8294C18.6304 20.9047 19.4264 19.441 20.2875 18.126C22.7308 14.3484 24.2246 12.0485 25.433 12.3003C26.6928 12.5476 26.2257 15.3738 28.123 20.9769C28.332 21.5767 28.8792 23.0739 29.0126 25.1241C29.0957 26.0445 29.1648 26.8116 28.9736 27.5506Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductWaterUsageIcon);
export default __webpack_public_path__ + "static/media/product-water-usage-icon.392dfa6ff3bbc1691b65d3590e8be52d.svg";
export { ForwardRef as ReactComponent };